import React from 'react'
import PropTypes from 'prop-types'

import { pick, get, isNumber } from 'lodash'
import { translate, utils } from 'parking-react-common'

import { parkingLots } from '../redux'

import Panel from '../components/Panel'
import Map from '../components/Map'
import MapPolygonsList from '../components/MapPolygonsList'

const [lat, lng] = utils.configVar('DEFAULT_MAP_COORDINATES')
const radius = utils.configVar('DEFAULT_MAP_RADIUS')
const defaultBounds = utils.boundsFromRadius({ lat, lng, radius })

const ParkingLotMapView = ({ item, t }) => {
    if (!item) {
        return null
    }

    const location = pick(item, ['lat', 'lng'])
    const hasLocation = isNumber(get(location, 'lat')) && isNumber(get(location, 'lng'))
    const bounds = parkingLots.getLocationBounds(item)

    return (
        <Panel title={ t('Location') } hasTable>
            <Map
                center={ hasLocation ? location : { lat, lng } }
                bounds={ bounds || defaultBounds }
            >
                <MapPolygonsList
                    data={ item.polygons }
                    color={ item.color }
                />
            </Map>
        </Panel>
    )
}

ParkingLotMapView.propTypes = {
    item: PropTypes.object
}

export default translate()(ParkingLotMapView)
